// ABOUTME: Hook that resolves the width of the ThreeViewLayout left drawer hosting a PimSideBar,
// ABOUTME: honoring the theme.sidebarWidth system setting and falling back to PIM_SIDEBAR_WIDTH.

import { PIM_SIDEBAR_WIDTH } from '@src/components/layout/PimSideBar';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext } from 'react';

export function usePimSidebarWidth(): string {
    const { theme } = useContext(SettingsContext);

    return theme?.sidebarWidth?.trim() || PIM_SIDEBAR_WIDTH;
}
